<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>
<div class="container mt-4 px-5">
    <div class="d-flex justify-content-end my-3">
        <button (click)="create()" class="btn btn-dark px-3 m">
            Create New Service

        </button>
    </div>
    <div class="bg-white rounded">
        <div class="reports-heading mb-0 mt-2 px-3 rounded-top-3">
            <div class="ms-1 top-bar-div">
                <div class="my-2 text-dark">
                    <h6>List of Configured Revenue Items</h6>
                </div>
            </div>

        </div>

        <table
                class="table table-striped table-hover table-bordered px-3"
        >
            <thead class="table-dark">
            <tr>
                <th class="assess-table-head">S/N</th>
                <th class="assess-table-head">Revenue Name</th>
                <th class="assess-table-head">Revenue Code</th>
                <th class="assess-table-head">Amount/Percentage</th>
                <th class="assess-table-head">Type</th>
                <th class="assess-table-head">Date Created</th>
                <th class="assess-table-head">Action</th>
            </tr>
            </thead>
            <ng-container *ngIf="!isSearching && details?.length > 0; else noDataTemplate">
                <tbody>
                <tr *ngFor="let d of details; let i = index">
                    <td>
                        <span class="badge bg-dark">{{ i + 1 + num }}</span>
                    </td>
                    <td>{{ d?.revenueName ? (d?.revenueName | titlecase) : "--" }}</td>
                    <td>{{ d?.revenueCode }}</td>
                    <td>{{d?.type === 'CUSTOM' ? 'N/A': d?.type === 'VARIABLE' ? d?.amount + '%': (d?.amount | nairaCurrency)}}</td>
                      
                    <td>{{ d?.type }}</td>
                    <td>{{ d?.timeCreated | date }}</td>
                    <td *ngIf="d?.type === 'CUSTOM'">
                        <button class="btn btn-success btn-sm btn-flat" (click)="view(d)">
                            View
                        </button>
                    </td>
                </tr>
                </tbody>
            </ng-container>
        </table>
        <div class="pagination justify-content-end">
            <ngb-pagination
                    *ngIf="!isSearching && details?.length > 0"
                    class="d-flex justify-content-center my-3"
                    [(page)]="currentPage"
                    (pageChange)="callDb($event)"
                    [maxSize]="5"
                    [pageSize]="pageSize"
                    [collectionSize]="count"
                    [boundaryLinks]="true"
                    [directionLinks]="true"
                    [rotate]="true"
            >
            </ngb-pagination>
        </div>

    </div>
</div>


<app-footer *ngIf="hasAccess(['ADMIN'])"></app-footer>
<app-mda-footer *ngIf="hasAccess(['MDA'])"></app-mda-footer>

<ng-template #noDataTemplate>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center align-items-center my-3">
                <ng-lottie
                        containerClass="mx-auto"
                        [options]="{ path: lottiePath, autoplay: true, loop: true }"
                        class="lottie-animation"
                ></ng-lottie>
                <div *ngIf="!isSearching && details?.length < 1;" class="message">No record found</div>
            </div>
        </td>
    </tr>
</ng-template>

